import React from 'react';
import { useParams, useLocation } from 'react-router-dom'; 
import EmbededPage from './embededPage';

const EmbeddedBooking = (props) => {
    const { businessUrl } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const primaryColor = queryParams.get('primaryColor') || '#1976d2';

    if (!businessUrl) {
        return <div>Loading...</div>;
    }

    return (
        <div style={{ padding: '20px' }}>
            <EmbededPage
                businessUrl={businessUrl}
                embedded={props?.embedded ?? true}
                primaryColor={primaryColor}
            />
        </div>
    );
};

export default EmbeddedBooking; 